<template>
  <footer
    class="mx-auto mb-4"
    style="height:50px"
  >
    <span class="float-md-left d-block d-md-inline-block mt-25">
      <span>Copyriaght &copy;</span>
      <span>{{ new Date().getFullYear() }} </span>
      <b-link
        href="https://headhuntershq.com"
        target="_blank"
        rel="nofollow"
      >HeadHunters HQ</b-link>
      <span class="d-sm-inline-block">, All rights Reserved | </span>
      <b-link
        href="/terms"
        target="_blank"
        rel="nofollow"
      >
        Terms of Service</b-link>
      <span>, </span>
      <b-link
        href="/privacy-policy"
        target="_blank"
        rel="nofollow"
      >Privacy Policy</b-link>
    </span>

    <span
      class="float-md-right d-none d-md-block"
    >Made with
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
  </footer>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
